import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';

class DeleteWishConfirmation extends Component {
  static propTypes = {
    onClose: PropTypes.func
  }

  handleDelete = () => {
    const { firebase, wishId } = this.props;
    firebase.remove(`wishes/${ wishId }`);
    this.handleClose();
  }

  handleClose = () => {
    const { onClose } = this.props;
    onClose && onClose();
  }

  render() {
    const { wish, open } = this.props;

    return (
      <Dialog onClose={ this.handleClose } aria-labelledby="delete-wish-confirmation-title" open={ open }>
        { open && <DialogTitle id="delete-wish-confirmation-title">Delete wish?</DialogTitle> }
        { open && <DialogContent><p>Are you sure you want to delete wish <strong>"{ wish.title }"</strong>?</p></DialogContent> }

        <DialogActions>
          <Button color="primary" onClick={ this.handleDelete }>
            <DeleteIcon /> Delete
          </Button>
          <Button color="primary" onClick={ this.handleClose }>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default DeleteWishConfirmation



// WEBPACK FOOTER //
// ./src/components/dialogs/DeleteWishConfirmation/DeleteWishConfirmation.js